// IMPORT PACKAGE REFERENCES
import * as React from "react";
import * as ReactDOM from "react-dom";

import './LoadingIndicator.scss';

// COMPONENT
interface ILoadingProps {
  busy: boolean;
  message?: string | null;
  targetElementId?: string;
}

const LoadingIndicator = (props: ILoadingProps) => {
  if (!props.busy) {
    return null;
  }

  if (props.targetElementId) {
    // Render inside a specific element
    return (
      <div className="showbox showbox-inline">
        <div className="loader">
          <svg className="circular" viewBox="25 25 50 50">
            <circle
              className="path"
              cx="50"
              cy="50"
              r="20"
              fill="none"
              strokeWidth="4"
              strokeMiterlimit="10"
            />
          </svg>
        </div>
      </div>
    );
  }

  // Original behavior: render as portal to full-screen loading indicator
  const container = document.getElementById("loading-indicator");
  if (!container) {
    console.warn('LoadingIndicator: Container element "loading-indicator" not found. Loading indicator will not be displayed.');
    return null;
  }

  return (
    <React.Fragment>
      {ReactDOM.createPortal(
        <div className="showbox">
          <div className="loader">
            <svg className="circular" viewBox="25 25 50 50">
              <circle
                className="path"
                cx="50"
                cy="50"
                r="20"
                fill="none"
                strokeWidth="4"
                strokeMiterlimit="10"
              />
            </svg>
          </div>
        </div>,
        container as Element
      )}
    </React.Fragment>
  );
};

// EXPORT COMPONENT
export { LoadingIndicator };
